<template>
    <div>
        <ConfigPanel :show.sync="parent.showConfigPanel" @optionsClick="parent.openConfigMenu($event)"></ConfigPanel>
        <ConfigUserPanel :show.sync="parent.showConfigUserPanel"></ConfigUserPanel>
        <ConfigConfigPanel :show.sync="parent.showConfigConfigPanel"></ConfigConfigPanel>
        <ConfigLocationPanel
            :show.sync="parent.showConfigLocationPanel"
            @optionsClick="openLocation($event)"
            @updateLocation="$emit('updateLocation', $event)"
        >
        </ConfigLocationPanel>
        <ConfigSpacePanel
            :location="location"
            :show.sync="parent.showConfigSpacePanel"
            @updateSpace="$emit('updateSpace', $event)"
        >
        </ConfigSpacePanel>
        <ConfigInfoPanel :show.sync="parent.showConfigInfoPanel"></ConfigInfoPanel>
    </div>
</template>

<script>
    import ConfigPanel from '../view_panels/ConfigPanel';
    import ConfigUserPanel from '../view_panels/ConfigUserPanel';
    import ConfigConfigPanel from '../view_panels/ConfigConfigPanel';
    import ConfigLocationPanel from '../view_panels/ConfigLocationPanel';
    import ConfigSpacePanel from '../view_panels/ConfigSpacePanel';
    import ConfigInfoPanel from '../view_panels/ConfigInfoPanel';

    export default {
        name: 'ConfigPanelMixinPanels',
        inject: ['parent'],
        components: {
            ConfigPanel,
            ConfigUserPanel,
            ConfigConfigPanel,
            ConfigLocationPanel,
            ConfigSpacePanel,
            ConfigInfoPanel,
        },
        data() {
            return {
                location: null,
            };
        },
        methods: {
            openLocation: function(location) {
                this.location = location;
                this.parent.openConfigMenu('space');
            },
        },
    };
</script>
